<template>
  <page>
    <div class="row">
      <div class="col-md-6 col-lg-4 col-md-push-3 col-lg-push-4">
        <div class="panel panel-default">
          <div class="panel-body text-center">
            <h3>Velja nýtt lykilorð</h3>

            <hr />

            <div class="alert alert-danger" v-if="errorList.length > 0" style="text-align: left;">
              <ul class="list-unstyled">
                <li v-for="(e, idx) in errorList" :key="idx">
                  {{ e }}
                </li>
              </ul>
            </div>

            <p class="text-left">
              Sláðu inn nýtt lykilorð tvisvar til staðfestingar. Lykilorð má vera 8-20 stafir og þarf að innihalda bæði bókstafi og tölustafi.
            </p>

            <br />

            <form novalidate @submit.prevent="validateBeforeSubmit">
              <div class="form-group" v-bind:class="{ 'has-error': errors.has('password') }">
                <label class="sr-only" for="password">Lykilorð</label>
                <input type="password" class="form-control" id="password" name="password" placeholder="Lykilorð" v-model="password" v-validate="'required'" />
                <span class="help-block" v-if="errors.has('password:required')">Vinsamlegast sláðu inn lykilorð.</span>
              </div>
              <div class="form-group" v-bind:class="{ 'has-error': errors.has('password2') }">
                <label class="sr-only" for="password2">Lykilorð aftur</label>
                <input
                  type="password"
                  class="form-control"
                  id="password2"
                  name="password2"
                  placeholder="Lykilorð aftur"
                  v-model="password2"
                  v-validate="'required'"
                />
                <span class="help-block" v-if="errors.has('password2:required')">Vinsamlegast sláðu inn lykilorð aftur.</span>
              </div>
              <button type="submit" class="btn btn-login" style="width: 100%; height: 40px;">STAÐFESTA</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </page>
</template>

<script>
/* global alert: false */

import config from '../services/config'
import auth from '../services/auth'
import router from '../router'

export default {
  name: 'password',
  data() {
    return {
      errorList: [],
      password: '',
      password2: '',
      formSubmitted: false
    }
  },
  methods: {
    validateBeforeSubmit() {
      this.errorList = []

      // Validate All returns a promise and provides the validation result.
      this.$validator.validateAll().then(success => {
        if (!success) {
          // handle error
          return
        }

        var credentials = {
          password: this.password,
          password2: this.password2
        }

        this.$http
          .post(config.PASSWORD_URL, credentials, {
            headers: auth.getAuthHeader()
          })
          .then(
            response => {
              auth.logout()
              router.push('innskraning?nytt_lykilord=true')
            },
            err => {
              if (err.status === 400 && 'message' in err.data) {
                this.errorList = [err.data.message]
              } else {
                alert('Óvænt villa kom upp. Vinsamlegast reyndu aftur.')
              }
            }
          )
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
